import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import VideosPage from "./pages/VideosPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () =>
<QueryClientProvider client={queryClient} data-id="3srgm1962" data-path="src/App.tsx">
    <TooltipProvider data-id="yjbdo7fop" data-path="src/App.tsx">
      <Toaster data-id="u9j6g203b" data-path="src/App.tsx" />
      <BrowserRouter data-id="ol34gs7eb" data-path="src/App.tsx">
        <Routes data-id="6i03belm8" data-path="src/App.tsx">
          <Route path="/" element={<HomePage data-id="t8h9iy7qc" data-path="src/App.tsx" />} data-id="k0mfkejcm" data-path="src/App.tsx" />
          <Route path="/blog" element={<BlogPage data-id="nck31u9e6" data-path="src/App.tsx" />} data-id="iegzwnhev" data-path="src/App.tsx" />
          <Route path="/videos" element={<VideosPage data-id="vy8ym7e32" data-path="src/App.tsx" />} data-id="36sug49bb" data-path="src/App.tsx" />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound data-id="ezqnxe6eb" data-path="src/App.tsx" />} data-id="bvhvermi9" data-path="src/App.tsx" />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>;


export default App;